<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="merge-request-auto-merge-card">
    <div class="merge-request-auto-merge-card__content">
      <div class="header">
        <div class="title">
          <i class="gf-icon gf-icon-git-branch"></i>
          <h6>{{ $t('page.autoMergeTitle') }}</h6>
        </div>
        <span
          class="status"
          :class="autoMergeStatusClass"
        >
          {{ autoMergeStatusText }}
        </span>
      </div>
      <div
        v-if="mergeRequest.autoMergeEnabled"
        class="user"
      >
        <span>{{ $t('page.enabledBy') }}</span>
        <a
          class="author"
          :href="`/user/${mergeRequest?.userSetToAutoMerge?.username}`"
        >
          <img
            :src="mergeRequest?.userSetToAutoMerge?.avatar"
            class="avatar"
            width="34px"
            height="34ox"
          />
          <b class="fullname">{{ mergeRequest?.userSetToAutoMerge?.fullName }}</b>
        </a>
      </div>
    </div>
    <div
      v-if="canToggleAutoMerge"
      class="merge-request-auto-merge-card__actions"
    >
      <gf-button
        class="enable-button"
        :text="enableAutoMergeButtonText"
        :variant="enableAutoMergeButtonVariant"
        :disabled="isRequestPending"
        @click="toggleAutoMerge"
      />
    </div>
  </section>
</template>

<script>
// eslint-disable-next-line max-len
import AutoMergeService from '@shared/modules/merge-request-auto-merge/merge-request-auto-merge.service';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
// eslint-disable-next-line max-len
import MergeRequestAutoMergeMessages from '@shared/modules/merge-request-auto-merge/merge-request-auto-merge.messages';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';

export default {
  name: 'MergeRequestAutoMergeCard',
  components: {
    GfButton
  },
  data() {
    return {
      isAutoMergeEnabledModel: false,
      isRequestPending: false
    };
  },
  computed: {
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    autoMergeStatusText() {
      return this.mergeRequest.autoMergeEnabled
        ? this.$t('message.enabled')
        : this.$t('message.disabled');
    },
    autoMergeStatusClass() {
      return this.mergeRequest.autoMergeEnabled
        ? 'gf-badge-outline-success-lg'
        : 'gf-badge-outline-danger-lg';
    },
    enableAutoMergeButtonText() {
      return this.mergeRequest.autoMergeEnabled
        ? this.$t('message.turn_off')
        : this.$t('message.turn_on');
    },
    enableAutoMergeButtonVariant() {
      return this.mergeRequest.autoMergeEnabled ? 'outline-danger' : 'success';
    },
    canToggleAutoMerge() {
      return (
        this.mergeRequest.autoMergeAllowed &&
        this.getActionAvailabilityFlag(ACTION_ENUM.TOGGLE_AUTO_MERGE)
      );
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    }
  },
  mounted() {
    this.isAutoMergeEnabledModel = this.mergeRequest?.autoMergeEnabled;
  },
  methods: {
    toggleAutoMerge() {
      this.isRequestPending = true;
      AutoMergeService.cancelAutoMergeForMergeRequestItem(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        !this.isAutoMergeEnabledModel
      ).then(() => {
        this.isRequestPending = false;
        this.isAutoMergeEnabledModel = !this.isAutoMergeEnabledModel;
      });
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    }
  },
  i18n: {
    messages: MergeRequestAutoMergeMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-auto-merge-card';

#{$this} {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--border-color);
  border-radius: 6px;

  @include theme.max-sm {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  #{$this}__content {
    display: flex;
    gap: 12px;
    align-items: center;
    white-space: nowrap;

    @include theme.max-xxl {
      flex-wrap: wrap;
      gap: 4px;
    }

    @include theme.max-sm {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }

    & > .header {
      display: flex;
      gap: 8px;
      align-items: center;

      @include theme.max-sm {
        flex-wrap: wrap;
        align-items: center;
      }

      & > .title {
        display: flex;
        align-items: center;
        gap: 4px;

        & > h6 {
          margin-bottom: 0;
        }
      }
    }
    & > .user {
      display: flex;
      align-items: center;
      gap: 8px;

      @include theme.max-sm {
        width: 100%;
        flex-wrap: wrap;
      }

      & > .author {
        display: flex;
        white-space: nowrap;
        align-items: center;
        gap: 8px;

        @include theme.max-sm {
          width: 100%;
        }

        & > .avatar {
          border-radius: 17px;
        }
        & > .fullname {
          max-width: 160px;
          color: var(--text);
          overflow: hidden;
          text-overflow: ellipsis;

          @include theme.max-xxl {
            max-width: 310px;
          }

          @include theme.max-xxl {
            max-width: 190px;
          }

          @include theme.max-sm {
            max-width: 100%;
          }
        }
      }
    }
  }

  #{$this}__actions {
    @include theme.max-sm {
      width: 100%;
    }

    & > .enable-button {
      @include theme.max-sm {
        width: 100%;
      }
    }
  }
}
</style>
